export default "__VITE_ASSET__DYoANCna__"